import { render, staticRenderFns } from "./RegRoadentsEdit.vue?vue&type=template&id=03356bba"
import script from "./RegRoadentsEdit.vue?vue&type=script&lang=js"
export * from "./RegRoadentsEdit.vue?vue&type=script&lang=js"
import style0 from "./RegRoadentsEdit.vue?vue&type=style&index=0&id=03356bba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports